function requireEnv(name) {
  const value = import.meta.env[name]
  if (!value) {
    throw new Error(`[配置错误] 缺少环境变量 ${name}`)
  }
  return value
}

// 生成 gameapi1~100 的备用节点列表
const _fallbackNodes = Array.from({ length: 100 }, (_, i) => ({
  api: `https://gameapi${i + 1}.fksgame.com`,
  ws:  `wss://gameapi${i + 1}.fksgame.com`
}))

// 应用配置
const config = {
  // API 基础地址（主节点）
  apiBaseUrl: requireEnv('VITE_API_BASE_URL'),
  // WebSocket 地址（主节点）
  wsBaseUrl: requireEnv('VITE_WS_BASE_URL'),
  // 备用节点列表（gameapi1~100.fksgame.com，自动轮询探活）
  fallbackNodes: _fallbackNodes,
  // 应用信息
  appName: '游戏平台',
  appVersion: '1.0.0',
  
  // 资源路径
  resBaseUrl: '/res',
  imgBaseUrl: '/res/img',
  soundBaseUrl: '/res/sound',
  
  // 游戏配置
  game: {
    // 默认游戏列表
    defaultGames: []
  },
  
  // 分页配置
  pagination: {
    pageSize: 20,
    pageSizes: [10, 20, 50, 100]
  },
  
  // 本地存储键名
  storage: {
    token: 'client_token',
    userInfo: 'client_user_info',
    settings: 'client_settings'
  }
}

export default config

